import React from 'react';
import PropTypes from 'prop-types';
import {
  Label,
  Input,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import HelpIcon from '../HelpIcon';

const ShareModalIncludeFutureFiles = ({
  disabled,
  includeFutureFiles,
  tooltip,
  handleChange,
}) => {
  const intl = useIntl();

  return (
    <div className="share-include-future-files">
      <div>
        <Label check>
          <Input
            type="checkbox"
            name="include-future-files"
            value={true}
            checked={includeFutureFiles}
            disabled={disabled}
            onChange={handleChange}
          />
          {' '}
          {intl.formatMessage({ defaultMessage: 'Update this link when new files or Collections are added' })}
          {(disabled && tooltip) && (
            <HelpIcon permanent={true} tooltip={true} url="https://help.stockpress.co/en/articles/11757271-smart-collections">
              {intl.formatMessage({ defaultMessage: 'This share contains a Smart Collection and must be updatable' })}
            </HelpIcon>
          )}
        </Label>
      </div>
    </div>
  );
};

ShareModalIncludeFutureFiles.propTypes = {
  disabled: PropTypes.bool.isRequired,
  includeFutureFiles: PropTypes.bool.isRequired,
  tooltip: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default ShareModalIncludeFutureFiles;
